import { TextField } from '@mui/material'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ObjectContext } from '../../../../contexts/objectContext/ObjectContext'

const CurrentContractStep: React.FC = () => {
	const { t } = useTranslation('modals_moveOutContact')
	const object = useContext(ObjectContext)

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			<TextField
				value={object.streetAddress}
				fullWidth
				title={t('currentContract.address')}
				label={t('currentContract.address')}
				variant='outlined'
				margin='normal'
				disabled={true}
			/>

			<TextField
				value={object.gsrn}
				fullWidth
				title={t('currentContract.gsrn')}
				label={t('currentContract.gsrn')}
				variant='outlined'
				margin='normal'
				disabled={true}
			/>
		</div>
	)
}

export default CurrentContractStep
